import type { IModuleStrings, IRecordTypeDefinition } from '@platform/core/types';

/**
 * Підпис фільтра поза меню (прототип v4 navKeyLabel для `f:`): «Поле: значення, значення» для кожної умови, умови — через « · »; підписи поля
 * й варіантів — рядки модуля мовою інтерфейсу; умова без значень — лише назва поля. Чиста функція.
 */
export function filterLabelOf(filter: string, rt: IRecordTypeDefinition, strings: IModuleStrings): string {
  return filter.split(';').filter(Boolean).map((condition) => {
    const [key = '', , raw = ''] = condition.split(':');
    const field = rt.fields.find((f) => f.key === key);
    const name = field ? strings.field(rt.key, key, field.label) : key;
    const values = raw ? raw.split(',').map((v) => {
      const value = decodeURIComponent(v);
      return strings.option(rt.key, key, value, field?.options?.find((o) => o.value === value)?.label ?? value);
    }) : [];
    return values.length ? `${name}: ${values.join(', ')}` : name;
  }).join(' · ');
}
